// extracted by mini-css-extract-plugin
export var content = "menuCarousel-module--content--9af01";
export var menuCarousel = "menuCarousel-module--menu-carousel--50df3";
export var track = "menuCarousel-module--track--c476b";
export var trackItem = "menuCarousel-module--track-item--cbb92";
export var trackWrapper = "menuCarousel-module--track-wrapper--b5472";